import { styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';

import { getCoreVersion } from '../../core';

const StyledBuildVersion = styled('div')({
  padding: 6,
  textAlign: 'center',
  position: 'absolute',
  bottom: 0,
  left: '50%',
  transform: 'translateX(-50%)',
  fontSize: 9,
  fontWeight: 300,
  color: 'var(--color-neutral-500)',
  zIndex: 2,
  whiteSpace: 'nowrap',
});

export const RouteWithVersion = () => {
  const [coreVersion, setCoreVersion] = useState('');

  const getBuildCoreVersion = async () => {
    const version = await getCoreVersion();
    setCoreVersion(version);
  };

  useEffect(() => {
    getBuildCoreVersion();
  }, []);

  return (
    <>
      <Outlet />
      <StyledBuildVersion>
        <strong>UI: </strong>
        {BUILD_VERSION} | <strong>CORE: </strong>
        {coreVersion}
      </StyledBuildVersion>
    </>
  );
};
